import axios from 'axios';

import { toApiError } from '@/shared/api/api-error';
import { env } from '@/shared/config/env';

import { adminToken } from './admin-token';

// Dedicated axios instance for the admin panel. Attaches the persisted admin
// Bearer token and, on a 401, clears the session and notifies the provider so
// it can redirect to the admin login. Kept separate from the storefront client.
export const adminClient = axios.create({
  baseURL: env.apiUrl,
  timeout: 20_000,
  headers: { Accept: 'application/json' },
});

let onUnauthorized;

export function setAdminUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

adminClient.interceptors.request.use((config) => {
  const token = adminToken.get();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      adminToken.clear();
      onUnauthorized?.();
    }
    throw toApiError(error);
  },
);
